/**
 * Full-screen auth splash shown while the session bootstraps and during the
 * Coherence sign-in bounce (a bare entry on a cookie-incapable host re-handshakes
 * with Coherence — see `coherence-auth`). It deliberately mirrors the static
 * `#boot-splash` in `index.html` 1:1 (same dark bg, sage spinner) so when
 * React replaces `#root` the handoff is seamless — no flash between the pre-JS
 * splash and this one, and the browser keeps this painted through the redirect.
 */
export function AuthLoadingScreen() {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
      }}
    >
      <div
        className="spin"
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          border: '3px solid var(--border)',
          borderTopColor: 'var(--horizon-glow)',
        }}
      />
    </div>
  );
}
